import classNames from "classnames";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import size from "lodash/size";
import string from "lodash/string";
import PropTypes from "prop-types";
import React, { Component } from "react";

import NotificationSlider from "./NotificationSlider";
import ChatActions from "../../actions/ChatActions";
import { createSanitizedMarkup } from "../../utils/Utils";

class ThreadViewHeaderTitle extends Component {
    constructor() {
        super();

        this.onToggleResponseSwitcher = this.onToggleResponseSwitcher.bind(this);
    }

    onToggleResponseSwitcher() {
        const { questionIsOneOnOne, responses, showResponseSwitcher } = this.props;

        if (questionIsOneOnOne || size(responses) === 0) {
            return undefined;
        }

        if (showResponseSwitcher) {
            ChatActions.hideResponseSwitcher();
        } else {
            ChatActions.showResponseSwitcher();
        }
    }

    render() {
        const {
            currentResponseId,
            latestAnswerForCurrentResponse,
            latestAnswerForAllResponses,
            questionIsOneOnOne,
            responses,
            showResponseSwitcher,
            unreadResponses,
        } = this.props;
        const headerTitleClasses = classNames({
            "thread-view-title-container": true,
            "has-notification": unreadResponses.length && !showResponseSwitcher,
        });
        const responseDots = responses.map((response, key) => {
            const responseClasses = classNames({
                "response-item": true,
                "is-current": response.id === currentResponseId,
            });

            return <li className={responseClasses} key={key} />;
        });
        const responseAuthorName = get(latestAnswerForCurrentResponse, "author.name", "");

        let title = null;
        if (showResponseSwitcher) {
            title = (
                <div>
                    <h1 className="header-title">
                        {responses.length} {i18n.t("rtm.text.answer", { count: responses.length })}
                    </h1>
                    {responses.length > 1 && <ul className="header-response-dots">{responseDots}</ul>}
                </div>
            );
        } else if (!questionIsOneOnOne && unreadResponses.length) {
            title = (
                <NotificationSlider
                    unreadResponses={unreadResponses}
                    latestAnswerForAllResponses={latestAnswerForAllResponses}
                />
            );
        } else if (!isEmpty(latestAnswerForCurrentResponse)) {
            title = (
                <div>
                    <h1 className="header-title" dangerouslySetInnerHTML={createSanitizedMarkup(responseAuthorName)} />
                    {responses.length > 1 && <ul className="header-response-dots">{responseDots}</ul>}
                </div>
            );
        } else {
            title = (
                <div>
                    <h1 className="header-title">Your question</h1>
                </div>
            );
        }

        return (
            <div
                className={headerTitleClasses}
                onClick={this.onToggleResponseSwitcher}
                data-latest-answer-author={string.unescape(responseAuthorName)}
            >
                {title}
            </div>
        );
    }
}

ThreadViewHeaderTitle.propTypes = {
    currentResponseId: PropTypes.number,
    latestAnswerForCurrentResponse: PropTypes.object,
    latestAnswerForAllResponses: PropTypes.object.isRequired,
    questionIsOneOnOne: PropTypes.bool.isRequired,
    responses: PropTypes.array.isRequired,
    showResponseSwitcher: PropTypes.bool.isRequired,
    unreadResponses: PropTypes.array.isRequired,
};

export default ThreadViewHeaderTitle;
